import React from 'react'
import { User } from 'src/core/models'
import { TFunction } from 'next-i18next'
import { CustomTextInput, CustomCheckBox, CustomFileInput } from 'src/components'

interface FormProps {
  name?: string,
  placeholder?: string,
  required?: boolean
  disabled?: boolean
  onChange?: Function
  text?: string
  handleChange?: Function
  defaultValue?: boolean
  isSmallText?: boolean
}

interface WithdrawalSection {
  isVisible: boolean,
  label: string
  formComponent: React.FunctionComponent<any>
  formProps: FormProps
}

export const withdrawalbankSections = (
  t: TFunction, IBAN: boolean, disableIBANNumber: boolean,
  handleIBANInputValue: Function, setIBAN: Function, disableAcountNumber: boolean,
  handleAccountNumberInputValue: Function, user: User,showInvoiceInput:boolean
): WithdrawalSection[] => [

  { // Beneficiary Name
    isVisible: true,
    label: t('Summary.BeneficiaryName'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'name',
      placeholder: t('Summary.BeneficiaryName'),
      required: true
    }
  },

  { // Beneficiary IBAN
    isVisible: !IBAN,
    label: t('Summary.BeneficiaryIBAN'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'iban',
      placeholder: t('Summary.BeneficiaryIBAN'),
      required: !disableIBANNumber,
      disabled: disableIBANNumber,
      onChange: handleIBANInputValue
    }
  },

  { // Check Box
    isVisible: true,
    label: null,
    formComponent: CustomCheckBox,
    formProps: {
      text: t('Summary.IBANCheckbox'),
      handleChange: (value: boolean) => setIBAN(value),
      defaultValue: IBAN,
      isSmallText: true
    }
  },

  { //Account Number
    isVisible: true,
    label: t('Summary.AccountNumber'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'account_number',
      placeholder: t('Summary.AccountNumber'),
      required: !disableAcountNumber,
      disabled: disableAcountNumber,
      onChange: handleAccountNumberInputValue
    }
  },

  { // Beneficiary SWIFT
    isVisible: true,
    label: t('Summary.BeneficiarySWIFT'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'swift',
      placeholder: t('Summary.BeneficiarySWIFT'),
      required: false
    }
  },

  { // Bank Name
    isVisible: true,
    label: t('Summary.BankName'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'bank_name',
      placeholder: t('Summary.BankName'),
      required: true
    }
  },

  { // Bank Address
    isVisible: true,
    label: t('Summary.BankAddress'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'bank_address',
      placeholder: t('Summary.BankAddress'),
      required: false
    }
  },

  { // Routing Number
    isVisible: true,
    label: t('Summary.RoutingNumber'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'routing_number',
      placeholder: t('Summary.RoutingNumber'),
      required: false
    }
  },

  { // Account Certificate
    isVisible: true,
    label: t('Summary.AccountCertificate'),
    formComponent: CustomFileInput,
    formProps: {
      name: 'cancellation_certificate',
      required: true
    }
  },

  { // Partnership Invoicde
    isVisible: showInvoiceInput,
    label: t('Summary.PartnershipInvoice'),
    formComponent: CustomFileInput,
    formProps: {
      name: 'partnership_invoice',
      required: true
    }
  },
]
